import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagKey } from './feature-flag.model';
import { FeatureFlagService } from './feature-flag.service';

/**
 * Functional route guard factory that allows activation only when the named
 * feature flag is enabled for the current tenant. If the flag is disabled,
 * the user is redirected to the home route.
 *
 * @example
 * ```ts
 * {
 *   path: 'custom-positions',
 *   canActivate: [featureFlagGuard(FeatureFlags.CustomPositions)],
 *   loadComponent: () => import('./custom-positions.component').then(m => m.CustomPositionsComponent),
 * }
 * ```
 */
export function featureFlagGuard(key: FeatureFlagKey): CanActivateFn {
  return () => {
    const flags = inject(FeatureFlagService);
    const router = inject(Router);
    if (flags.isEnabled(key)) {
      return true;
    }
    return router.createUrlTree(['/']);
  };
}
